(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nwly-size-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    const drawer = document.getElementById('nwly-size-drawer');
    if (!drawer) return;
    if (link && !link.closest('dialog') && new URL(link.href, location.href).pathname === '/pages/size-guide' && document.querySelector('main[data-template^="product"]')) {
      event.preventDefault();
      window.nwlySizeTrigger = link;
      drawer.showModal();
      drawer.querySelector('[data-size-close]').focus();
    }
    if (event.target.closest('[data-size-close]')) drawer.close();
    if (event.target === drawer) {
      const rect = drawer.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right) drawer.close();
    }
  });
  document.getElementById('nwly-size-drawer')?.addEventListener('close', () => window.nwlySizeTrigger?.focus({preventScroll:true}));
  } catch(e) { console.error(e); }
})();

})();
